export const search_list = [
    {
      type: "input",
      label: "姓名",
      props: 'cert_name',
    },
    {
      type: "input",
      label: "手机号",
      props: 'phone',
    },
    {
      type: "input",
      label: "保单凭证号",
      props: 'policy_no',
    },
    {
      type: "date",
      label: "保单时间",
      props: 'date',
      disabledEmty: true,
      format: "YYYY-MM-DD HH:mm:ss",
      propsConfig: {
        showTime: false,
        format: "YYYY-MM-DD HH:mm:ss",
      },
    },
    {
      type: 'select',
      label: '参保状态',
      props: 'policy_status',
      selectData: [
        {
          label: '参保中',
          value: '1'
        },
        {
          label: '参保已过期',
          value: '0'
        }
      ]
    },
  ];
  
  export const tableColumns = [
    {
      title: "企业名称",
      value: 'company_name',
      header_align: 'center',
      align: 'center',
      width: 180
    },
    {
      title: "保险套餐名称",
      value: 'product_type',
      header_align: 'center',
      align: 'center',
      width: 150
    },
    {
      title: "保单产品名称",
      value: "product_name",
      header_align: 'center',
      align: 'center',
      width: 260
    },
    {
      title: "姓名",
      value: "cert_name",
      header_align: 'center',
      align: 'center',
      width: 100
    },
    {
      title: "手机号",
      value: "phone",
      header_align: 'center',
      align: 'center',
      width: 130
    },
    {
      title: "保单凭证号",
      value: "policy_no",
      header_align: 'center',
      align: 'center',
      width: 200
    },
    {
      title: "保单生效时间",
      value: "effect_start_time",
      header_align: 'center',
      align: 'center',
      width: 180
    },
    {
      title: "保单失效时间",
      value: "effect_end_time",
      header_align: 'center',
      align: 'center',
      width: 180
    },
    {
      title: "保费(单位元)",
      value: "premium",
      header_align: 'center',
      align: 'center',
      width: 130
    },
    {
      title: "保额(单位元)",
      value: "sum_insured",
      header_align: 'center',
      align: 'center',
      width: 130
    },
    {
      title: "投保场景打卡模式",
      value: "is_clock_work_text",
      header_align: 'center',
      align: 'center',
      width: 160
    },
    {
      title: "保单状态",
      value: "policy_status_text",
      header_align: 'center',
      align: 'center',
      width: 110
    },
    {
      title: "退保金额(单位元)",
      value: "surrender_amount",
      header_align: 'center',
      align: 'center',
      width: 150
    },
    {
      title: "退保时间",
      value: "surrender_time",
      header_align: 'center',
      align: 'center',
      width: 180
    },
  ];
  export const actionGroup = [
    {
      name: "查看",
      flag: "show",
    }
  ];
  
  export const form_list = [
    {
      type: "input",
      label: "姓名",
      props: "cert_name",
      disabled: true,
    },
    {
      type: "input",
      label: "手机号",
      props: "phone",
      disabled: true,
    },
    {
      type: "input",
      label: "投保场景",
      props: "is_clock_work_text",
      disabled: true,
    },
    {
      type: "input",
      label: "保单凭证号",
      props: "policy_no",
      disabled: true,
    },
    {
      type: "input",
      label: "生效时间",
      props: "effect_start_time",
      disabled: true,
    },
    {
      type: "input",
      label: "失效时间",
      props: "effect_end_time",
      disabled: true,
    },
    {
      type: "input",
      label: "保费",
      props: "premium",
      disabled: true,
      append: "元"
    },
    {
      type: "input",
      label: "保额",
      props: "sum_insured",
      disabled: true,
      append: "元"
    },
    {
      type: "input",
      label: "保单状态",
      props: "policy_status_text",
      disabled: true,
    },
    {
      type: "input",
      label: "退保金额",
      props: "surrender_amount",
      disabled: true,
      append: "元"
    },
    {
      type: "input",
      label: "退保时间",
      props: "surrender_time",
      disabled: true,
    },
  ];
  